import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private fixVxloader: boolean = false;

  public showVxLoader: boolean = false;
  public showVxLoader$: EventEmitter<boolean> = new EventEmitter();

  constructor() {}

  public show(value: boolean = true) {
    if (!this.fixVxloader) {
      this.showVxLoader = value;
      this.showVxLoader$.next(this.showVxLoader);
    }
  }

  public fix(value: boolean = true) {
    this.fixVxloader = value;
  }
}
